import "./App.css";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import Mainlayout from "./layout/Mainlayout";
import AdminLayout from "./layout/AdminLayout";
import Monitors from "./pages/Monitors";
import Login from "./pages/Login";
import PrivateRoute from "./components/PrivateRoute";
import AdminRoute from "./components/AdminRoute";
import { AuthProvider } from "./context/AuthProvider";
import GeneralSettings from "./pages/GeneralSettings";
import AddMonitor from "./pages/AddMonitor";
import ForwardingOptions from "./components/ForwardingOptions";
import MonitorHealth from "./pages/MonitorHealth";
import MonitorDetail from "./pages/MonitorDetail";
import Alerts from "./pages/Alerts";
import BandwidthCost from "./pages/BandwidthCost";
import ProxyManagement from "./pages/ProxyManagement";
import AdminProducts from "./pages/AdminProducts";
import AdminRuntimeValidation from "./pages/AdminRuntimeValidation";
import StaleMonitors from "./pages/StaleMonitors";
import AdminObservability from "./pages/AdminObservability";
import MonitorLogs from "./pages/MonitorLogs";
import AdminClients from "./pages/AdminClients";

function App() {
  return (
    <AuthProvider>
      <Router>
        <Routes>
          <Route path="/login" element={<Login />} />
          {/* Protected routes */}
          <Route element={<PrivateRoute />}>
            <Route path="/" element={<Mainlayout />}>
              {/*<Route index element={<General />} />*/}
              <Route index path="/" element={<GeneralSettings />} />
              <Route path="/monitors" element={<Monitors />} />
              <Route path="/monitors/add-monitor" element={<AddMonitor />} />
              <Route
                path="/forwarding/add-forwards"
                element={<ForwardingOptions />}
              />

              <Route path="/monitors/health" element={<MonitorHealth />} />
              <Route path="/monitors/health/:monitorName" element={<MonitorDetail />} />
              <Route path="/alerts" element={<Alerts />} />
              <Route path="/bandwidth" element={<BandwidthCost />} />
              {/*<Route path="/changelog" element={<Changelogs />} />*/}
            </Route>

            {/* Admin area — URL-only access, gated by client ID */}
            <Route path="/admin" element={<AdminRoute />}>
              <Route element={<AdminLayout />}>
                <Route index element={<Navigate to="/admin/health" replace />} />
                <Route path="health" element={<MonitorHealth />} />
                <Route path="health/:monitorName" element={<MonitorDetail />} />
                <Route path="alerts" element={<Alerts />} />
                <Route path="bandwidth" element={<BandwidthCost />} />
                <Route path="runtime" element={<AdminRuntimeValidation />} />
                <Route path="proxies" element={<ProxyManagement />} />
                <Route path="products" element={<AdminProducts />} />
                <Route path="clients" element={<AdminClients />} />
                <Route path="stale" element={<StaleMonitors />} />
                <Route path="observability/:code" element={<AdminObservability />} />
                <Route path="logs" element={<MonitorLogs />} />
                <Route path="logs/:code" element={<MonitorLogs />} />
              </Route>
            </Route>
          </Route>
        </Routes>
      </Router>
    </AuthProvider>
  );
}

export default App;
